import { useState } from 'react';
import GearPicker from './GearPicker.jsx';
import SeatStrip from './SeatStrip.jsx';
import { formatTime, initials } from '../lib/format.js';

/** Take one of the seats in a given car. */
export default function JoinForm({ ride, me, color, gearSuggestions, onSubmit, onCancel, busy, error }) {
  const [form, setForm] = useState({
    phone: me?.phone ?? '',
    pickupStopId: '',
    gear: [],
    note: '',
  });
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));

  const submit = (event) => {
    event.preventDefault();
    if (busy) return;
    onSubmit({
      phone: form.phone.trim(),
      pickupStopId: form.pickupStopId || null,
      gear: form.gear,
      note: form.note.trim(),
    });
  };

  return (
    <form onSubmit={submit} className="stack gap-16">
      {error && <div className="toast error" style={{ borderRadius: 10 }}>⚠ <span>{error}</span></div>}

      <div className="ride" style={{ '--ride-color': color }}>
        <div className="ride-head" style={{ cursor: 'default' }}>
          <span className="ride-avatar">{initials(ride.driver.name)}</span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span className="ride-name">{ride.driver.name}</span>
            <span className="ride-sub truncate" style={{ display: 'block' }}>
              Depart de {ride.origin.label} a {formatTime(ride.departureTime)}
            </span>
            <span style={{ display: 'block', marginTop: 7 }}>
              <SeatStrip
                seats={ride.seats}
                driverName={ride.driver.name}
                passengers={ride.passengers}
                color={color}
                variant="detailed"
              />
            </span>
          </span>
        </div>
      </div>

      {/* Identity is already settled, so this only asks what the driver needs. */}
      <div className="row gap-10">
        <span className="whoami-avatar" style={{ width: 30, height: 30, fontSize: 12 }}>
          {initials(me?.name)}
        </span>
        <span className="small" style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontWeight: 600 }}>{me?.name}</span>
          <span className="faint">Vous reservez une place sous ce nom.</span>
        </span>
      </div>

      <div className="field">
        <label htmlFor="jf-phone">Telephone</label>
        <input
          id="jf-phone"
          className="input"
          type="tel"
          value={form.phone}
          onChange={(e) => set({ phone: e.target.value })}
          placeholder="06 12 34 56 78"
        />
        <span className="field-hint">Pour que le conducteur puisse vous joindre.</span>
      </div>

      <div className="field">
        <label htmlFor="jf-stop">Ou montez-vous ?</label>
        <select
          id="jf-stop"
          className="select"
          value={form.pickupStopId}
          onChange={(e) => set({ pickupStopId: e.target.value })}
        >
          <option value="">Au point de depart — {ride.origin.label}</option>
          {ride.stops.map((s, i) => (
            <option key={s.id} value={s.id}>
              Arret {i + 1} — {s.place.label}
              {s.eta ? ` (${s.etaEstimated ? '~ ' : ''}${formatTime(s.eta)})` : ''}
            </option>
          ))}
        </select>
        {ride.stops.length === 0 && (
          <span className="field-hint">Ce trajet n'a pas d'arret intermediaire pour l'instant.</span>
        )}
      </div>

      <GearPicker
        value={form.gear}
        onChange={(gear) => set({ gear })}
        suggestions={gearSuggestions}
        label="Materiel que vous apportez"
      />

      <div className="field">
        <label htmlFor="jf-note">Note</label>
        <input
          id="jf-note"
          className="input"
          value={form.note}
          onChange={(e) => set({ note: e.target.value })}
          placeholder="Je rentre peut-etre avec quelqu'un d'autre..."
          maxLength={300}
        />
      </div>

      <div className="row gap-10">
        <button type="submit" className="btn btn-primary" disabled={busy}>
          {busy && <span className="spinner" />}
          Reserver ma place
        </button>
        <button type="button" className="btn btn-ghost" onClick={onCancel}>Annuler</button>
      </div>
    </form>
  );
}
